import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { InputFieldComponent } from 'src/app/components/form/input-field/input-field.component';
import { AlertInfo } from 'src/app/models/alert-info';
import { SavedDataInfo } from 'src/app/models/form/saved-data-info';
import { AlertNotificationService } from 'src/app/services/alert-notification.service';
import { ProjectsService } from 'src/app/services/api/projects.service';
import { FormService } from 'src/app/services/form.service';

@Component({
  selector: 'settings-projects-checklist-group-form',
  imports: [ReactiveFormsModule, NgbAlert, InputFieldComponent],
  templateUrl: './settings-projects-checklist-group-form.component.html',
  styleUrl: './settings-projects-checklist-group-form.component.scss'
})
export class SettingsProjectsChecklistGroupFormComponent implements OnInit, OnChanges {

  @Input() checklistGroup?: any;
  @Output() onSavedData = new EventEmitter<SavedDataInfo>();

  form!: FormGroup;
  alertInfo: AlertInfo = { show: false, type: '', message: '' };

  constructor(
    private formService: FormService,
    private alertNotificationService: AlertNotificationService,
    private projectsService: ProjectsService
  ) {}

  ngOnInit(): void {
    this.form = new FormGroup({
      code: new FormControl('', [Validators.required]),
      name: new FormControl('', [Validators.required])
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['checklistGroup'] && changes['checklistGroup'].currentValue && this.form) {
      const group = changes['checklistGroup'].currentValue;
      this.form.patchValue({ code: group.code, name: group.name });
    }
  }

  getCodeInput(): FormControl { return this.form.get('code') as FormControl; }
  getName(): FormControl { return this.form.get('name') as FormControl; }

  showAlertInfo(type: string, message: string): void {
    this.alertInfo = { show: true, type, message };
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => { this.alertInfo.show = false; }, 3000);
  }

  submitForm(): void {
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key)?.markAsTouched();
      this.form.get(key)?.updateValueAndValidity();
    });

    if (!this.form.valid) return;

    const { code, name } = this.form.getRawValue();
    this.alertInfo.show = false;
    this.formService.resetErrors(this.form);

    const serviceCall = this.checklistGroup
      ? this.projectsService.updateSettingsChecklistGroup(this.checklistGroup.checklistGroupId, {
          checklistGroupId: this.checklistGroup.checklistGroupId,
          tenantId: 1,
          code,
          name
        })
      : this.projectsService.createSettingsChecklistGroup({ tenantId: 1, code, name });

    serviceCall.subscribe({
      next: (response: any) => {
        this.alertNotificationService.success('Operation completed successfully');
        this.showAlertInfo('success', 'Operation completed successfully');
        this.onSavedData.emit({ success: true, response });
      },
      error: (error: any) => {
        if (error?.error?.error?.description === 'ARGUMENT_VALIDATION_ERROR') {
          this.formService.resetErrors(this.form);
          this.formService.setValidationErrors(this.form, error.error.error.validationErrors);
        } else {
          this.showAlertInfo('danger', error?.error?.error?.message || 'An error occurred');
        }
        this.onSavedData.emit({ success: false, error });
      }
    });
  }
}
